// @tennis-matches/services/governance
// Pro-Nutzer-Freigabe für Ballmates KI (app_entitlements.app_key = ballmates-ki).

export const BALLMATES_KI_APP_KEY = "ballmates-ki";

function __asStr(v) {
  return String(v ?? "").trim();
}

function __normalizeAppKey(appKey) {
  return __asStr(appKey).toLowerCase();
}

/**
 * @param {unknown} row
 */
export function isBallmatesKiEntitlementRow(row) {
  return __normalizeAppKey(row?.app_key) === BALLMATES_KI_APP_KEY;
}

/**
 * @param {unknown[]} entitlements
 * @param {{ isGlobalSuperadmin?: boolean }} [opts]
 */
export function hasBallmatesKiAccessFromEntitlements(
  entitlements,
  { isGlobalSuperadmin = false } = {},
) {
  if (isGlobalSuperadmin) return true;
  const rows = Array.isArray(entitlements) ? entitlements : [];
  return rows.some(
    (e) => isBallmatesKiEntitlementRow(e) && e.enabled !== false,
  );
}

/**
 * @param {import('@supabase/supabase-js').SupabaseClient} sb
 * @param {{ authUser?: object | null }} [opts]
 */
export async function resolveBallmatesKiAccessRemote(
  sb,
  { authUser = null } = {},
) {
  if (!sb) return false;

  try {
    const { data: isSa, error: saErr } = await sb.rpc("is_superadmin");
    if (!saErr && isSa === true) return true;
  } catch (_) {
    // fall through
  }

  try {
    const { data, error } = await sb.rpc("list_my_app_entitlements");
    if (!error && Array.isArray(data)) {
      return hasBallmatesKiAccessFromEntitlements(data, {
        isGlobalSuperadmin: false,
      });
    }
  } catch (_) {
    // fall through
  }

  return hasBallmatesKiAccessFromEntitlements([], {
    isGlobalSuperadmin: false,
  });
}
